const STATE_UP = 'UP';
const STATE_DOWN = 'DOWN';

export default class Slideable {

	constructor(element, duration = 300, targetDisplay = 'block') {
		this.element = element;
		this.duration = duration;
		this.originalStyle = {};
		this.targetDisplay = targetDisplay;
		this.originalDisplay = null;
		this.state = STATE_UP;
	}

	_prepare() {
		this._calculateSize();

		Object.assign(this.originalStyle, this.element.style);
		this.originalDisplay = window.getComputedStyle(this.element).display;

		Object.assign(
			this.element.style,
			{
				overflow: 'hidden',
				transition: `height ${this.duration}ms cubic-bezier(0.37, 0, 0.63, 1)`,
			},
		);
	}

	_finalize() {
		this.element.style = this.originalStyle;

		if (this.state === STATE_UP && this.isHidden())
			this.element.style.display = this.targetDisplay;

		if (this.state === STATE_DOWN && !this.isHidden())
			this.element.style.display = 'none';
	}

	_calculateSize() {
		let display = window.getComputedStyle(this.element).display;
		if (this.isHidden()) {
			this.element.style.display = 'block';
		}
		this.height = this.element.getBoundingClientRect().height;
		this.element.style.display = display;
	}

	down(callbackDown = null) {
		this.state = STATE_UP;
		this._prepare();

		this.element.style.height = '0';
		this.element.style.display = this.originalDisplay === 'none' ? 'block' : this.originalDisplay;

		setTimeout(() => {
			this.element.style.height = this.height + 'px';
		}, 10);

		setTimeout(() => {
			this._finalize();

			if (typeof callbackDown === 'function') callbackDown();
		}, this.duration + 10);
	}

	up(callbackUp = null) {
		this.state = STATE_DOWN;
		this._prepare();
		this.element.style.height = this.height + 'px';

		setTimeout(() => {
			this.element.style.height = 0;
		}, 10);

		setTimeout(() => {
			this.element.style.display = 'none';
			this._finalize();

			if (typeof callbackUp === 'function') callbackUp();
		}, this.duration + 10);

	}

	toggle(callbackUp = null, callbackDown = null) {
		if (this.isHidden()) return this.down(callbackDown);
		else this.up(callbackUp);
	}

	isHidden() {
		return window.getComputedStyle(this.element).display === 'none';
	}
}
